import { commonImages } from '@images/common-images';
import { reportImages } from '@images/reports-images';
import moment from 'moment';
import { RefineReports } from './report';

export class createReport {
  public static dateRangeTitel: any = {
    last_seven_days: 'Last 7 Days',
    prev_week: 'Last week',
    last_two_weeks: 'Last 2 Weeks',
    this_week: 'This week',
    this_month: 'This month',
    this_quarter: 'This quarter',
    this_financial_year: 'This financial year',
    last_month: 'Last month',
    last_financial_year: 'Last financial year',
    month_to_date: 'Month to date',
    last_quarter: 'Last quarter',
    quarter_to_date: 'Quarter to date',
    year_to_date: 'Year to date',
    calendar_year: 'Calendar year',
    all: 'All',
    weekly_stats: 'Chart Per Week',
  };

  public static refine_reports: RefineReports[] = [
    {
      title: 'Lead Management',
      type: 'lead_management',
      obj: 'lead_management',
      tag: 'lead',
      view: 'leads',
      img: reportImages?.lead_icon,
      isSelected: false,
      isOpen: true,
    },
    {
      title: 'Properties',
      view: 'properties_views',
      type: 'properties_data',
      obj: 'properties_data',
      tag: 'lead',
      img: reportImages?.home_icon,
      isSelected: false,
      isOpen: true,
    },
    {
      title: 'Listing',
      type: 'properties',
      obj: 'properties',
      view: 'listings',
      tag: 'listing',
      img: reportImages?.home_icon,
      isSelected: false,
      isOpen: true,
    },
    {
      title: 'Contacts',
      type: 'contacts',
      obj: 'contacts',
      view: 'contact',
      tag: 'contacts',
      img: reportImages?.contact_icon,
      isSelected: false,
      isOpen: true,
    },
    // {
    //   title: 'Task Manager',
    //   type: 'tasks',
    //   obj: 'tasks',
    //   img: reportImages?.task_icon,
    //   isSelected: false,
    //   isOpen: true,
    // },
    {
      title: 'Projects',
      type: 'projects',
      obj: 'projects',
      tag: 'project',
      view: 'projects',
      img: reportImages?.project_icon,
      isSelected: false,
      isOpen: true,
    },
    {
      title: 'Units',
      type: 'project_units',
      obj: 'project_units',
      tag: 'project',
      view: 'priceList',
      img: commonImages?.home_icon,
      isSelected: false,
      isOpen: true,
    },
    {
      title: 'EOI',
      type: 'eoi',
      obj: 'eoi',
      view: 'project_eoi',
      tag: 'project',
      img: commonImages?.project_1_icon,
      isSelected: false,
      isOpen: true,
    },
    {
      title: 'OFI',
      type: 'ofi',
      obj: 'ofi',
      tag: 'project',
      view: 'ofi',
      img: commonImages?.home_icon,
      isSelected: false,
      isOpen: true,
    },
    {
      title: 'Contract',
      type: 'contract',
      obj: 'contract',
      tag: 'contract',
      view: 'contracts',
      img: commonImages?.contract_icon,
      isSelected: false,
      isOpen: true,
    },
    {
      title: 'Staff',
      type: 'staff',
      obj: 'staff',
      tag: 'contact',
      view: 'contact',
      img: commonImages?.right_user_icon,
      isSelected: false,
      isOpen: true,
    },
    // {
    //   title: 'KPI',
    //   type: 'kpi',
    //   class: 'coming_soon',
    //   obj: 'kpi',
    //   tag: 'project',
    //   img: reportImages?.entity_icon,
    //   isSelected: false,
    //   isOpen: true,
    // },
    // {
    //   title: 'Commission',
    //   class: 'coming_soon',
    //   type: 'commission',
    //   obj: 'commission',
    //   tag: 'project',
    //   img: commonImages?.conjunction_icon,
    //   isSelected: false,
    //   isOpen: true,
    // },
  ];

  public static formats: any[] = [
    { id: 1, name: 'Text' },
    { id: 101, name: 'Email' },
    { id: 102, name: 'Text' },
    { id: 103, name: 'Address (google search)' },
    { id: 2, name: 'Numbers' },
    { id: 203, name: 'Currency (AUD)' },
    { id: 201, name: 'Text' },
    { id: 202, name: 'Text' },
    { id: 3, name: 'True/False' },
    { id: 301, name: 'Object' },
    { id: 302, name: 'Dynamic Floorplan' },
    { id: 303, name: 'Complete/Incomplete Switch' },
    { id: 4, name: 'Text' },
    { id: 5, name: 'Selection' },
    { id: 501, name: 'Selection' },
    { id: 502, name: 'Role Based Option Set (Radio Group)' },
    { id: 503, name: 'Selection' },
    { id: 504, name: 'Selection' },
    { id: 505, name: 'Selection' },
    { id: 506, name: 'Auto Complete' },
    { id: 6, name: 'Selection' },
    { id: 7, name: 'Date' },
    { id: 8, name: 'Time' },
    { id: 9, name: 'Selection' },
    { id: 111, name: 'File Upload' },
    { id: 112, name: 'Image Upload' },
  ];

  /** Calendar quarters (Jan–Mar, Apr–Jun, Jul–Sep, Oct–Dec). */
  private static calendarQuarterBounds(m: moment.Moment) {
    const quarterStartMonth = Math.floor(m.month() / 3) * 3;
    const start = m.clone().month(quarterStartMonth).startOf('month');
    const end = start.clone().add(3, 'months').subtract(1, 'day');
    const lastStart = start.clone().subtract(3, 'months');
    const lastEnd = start.clone().subtract(1, 'day');
    return { start, end, lastStart, lastEnd };
  }

  /** Financial year July 1 – June 30 (Australian-style). */
  private static fiscalYearJulyJune(m: moment.Moment) {
    const fiscalYearStartMonth = 6; // July (0-based)
    const y = m.year();
    if (m.month() >= fiscalYearStartMonth) {
      return {
        current: {
          start: moment({ year: y, month: fiscalYearStartMonth, day: 1 }),
          end: moment({ year: y + 1, month: fiscalYearStartMonth, day: 1 }).subtract(1, 'day'),
        },
        last: {
          start: moment({ year: y - 1, month: fiscalYearStartMonth, day: 1 }),
          end: moment({ year: y, month: fiscalYearStartMonth, day: 1 }).subtract(1, 'day'),
        },
      };
    }
    return {
      current: {
        start: moment({ year: y - 1, month: fiscalYearStartMonth, day: 1 }),
        end: moment({ year: y, month: fiscalYearStartMonth, day: 1 }).subtract(1, 'day'),
      },
      last: {
        start: moment({ year: y - 2, month: fiscalYearStartMonth, day: 1 }),
        end: moment({ year: y - 1, month: fiscalYearStartMonth, day: 1 }).subtract(1, 'day'),
      },
    };
  }

  public static loadDateRange = () => {
    const m = moment();
    const q = createReport.calendarQuarterBounds(m);
    const fy = createReport.fiscalYearJulyJune(m);
    const lastWeek = m.clone().subtract(1, 'week');
    const lastMonth = m.clone().subtract(1, 'months');

    return [
      {
        id: 15,
        name: 'Last 7 Days',
        subname: 'Last 7 Days',
        format: 'dd MMM YYYY',
        from: m.clone().subtract(6, 'days').startOf('day').toDate(),
        to: m.clone().endOf('day').toDate(),
      },
      {
        id: 11,
        subname: 'Last week',
        name: 'Last Week',
        format: 'dd MMM YYYY',
        from: lastWeek.clone().startOf('isoWeek').toDate(),
        to: lastWeek.clone().endOf('isoWeek').toDate(),
      },
      {
        id: 12,
        subname: 'This week',
        name: 'This Week',
        format: 'dd MMM YYYY',
        from: m.clone().startOf('isoWeek').toDate(),
        to: m.clone().endOf('isoWeek').toDate(),
      },
      {
        id: 1,
        name: 'This Month',
        subname: 'This Month',
        format: 'MMM YYYY',
        from: m.clone().startOf('month').toDate(),
        to: m.clone().endOf('month').toDate(),
      },
      {
        id: 7,
        name: 'Month To Date',
        subname: 'Month to date',
        format: 'dd MMM YYYY',
        from: m.clone().startOf('month').toDate(),
        to: m.clone().toDate(),
      },
      {
        id: 4,
        name: 'Last Month',
        subname: 'Prev Month',
        format: 'MMM YYYY',
        from: lastMonth.clone().startOf('month').toDate(),
        to: lastMonth.clone().endOf('month').toDate(),
      },
      {
        id: 2,
        name: 'This Quarter',
        subname: 'This Quarter',
        format: 'MMM YYYY',
        from: q.start.toDate(),
        to: q.end.toDate(),
      },
      {
        id: 8,
        name: 'Quarter To Date',
        subname: 'Quarter To Date',
        format: 'dd MMM YYYY',
        from: q.start.clone().startOf('month').toDate(),
        to: m.clone().toDate(),
      },
      {
        id: 5,
        name: 'Last Quarter',
        subname: 'Prev Quarter',
        format: 'MMM YYYY',
        from: q.lastStart.toDate(),
        to: q.lastEnd.toDate(),
      },
      {
        id: 9,
        name: 'Year To Date',
        subname: 'Year To Date',
        format: 'dd MMM YYYY',
        from: m.clone().startOf('year').toDate(),
        to: m.clone().toDate(),
      },
      {
        id: 13,
        name: 'Calendar Year',
        subname: 'Yearly',
        format: 'dd MMM YYYY',
        from: m.clone().startOf('year').toDate(),
        to: m.clone().endOf('year').toDate(),
      },
      {
        id: 3,
        name: 'This Financial Year',
        subname: 'This Financial Year',
        format: 'dd MMM YYYY',
        from: fy.current.start.toDate(),
        to: fy.current.end.toDate(),
      },
      {
        id: 6,
        name: 'Last Financial Year',
        subname: 'Last Financial Year',
        format: 'dd MMM YYYY',
        from: fy.last.start.toDate(),
        to: fy.last.end.toDate(),
      },
      {
        id: 10,
        name: 'All',
        subname: 'All',
        format: 'dd MMM YYYY',
        to: m.clone().toDate(),
      },
      {
        id: 14,
        name: 'Custom',
        subname: 'Custom',
        format: 'dd MMM YYYY',
        from: '',
        to: '',
      },
    ];
  };

  /** Report-level id of {@link loadLastTwoWeeksRange}. Not in `loadDateRange()` on purpose — see there. */
  public static readonly LAST_TWO_WEEKS_ID = 16;

  /**
   * "Last 2 Weeks" — the two most recently completed Monday–Sunday weeks (the week before last plus
   * last week), so it lines up with "Last Week" rather than rolling back 14 days from today.
   *
   * Deliberately NOT part of `loadDateRange()`: that list also feeds My Listings, Profile Commission
   * and every other report template's picker, and this preset is only offered on Project Insights
   * (see `RpDateRangeComponent.dateRange`). Anything that has to resolve a stored range by id/name
   * reads {@link loadDateRangeCatalog} instead, which includes it.
   */
  public static loadLastTwoWeeksRange = () => {
    const m = moment();
    return {
      id: createReport.LAST_TWO_WEEKS_ID,
      name: 'Last 2 Weeks',
      subname: 'Last 2 Weeks',
      format: 'dd MMM YYYY',
      from: m.clone().subtract(2, 'weeks').startOf('isoWeek').toDate(),
      to: m.clone().subtract(1, 'week').endOf('isoWeek').toDate(),
    };
  };

  /** `loadDateRange()` plus presets only some screens offer — for resolving a stored range by id/name. */
  public static loadDateRangeCatalog = () => [...createReport.loadDateRange(), createReport.loadLastTwoWeeksRange()];

  public static ChartPer: any[] = [
    { var: 'last_seven_days', name: 'Last 7 Days', id: 15 },
    { var: 'prev_week', name: 'Last week', id: 11 },
    { var: 'last_two_weeks', name: 'Last 2 Weeks', id: createReport.LAST_TWO_WEEKS_ID },
    { var: 'this_week', name: 'This week', id: 12 },
    { var: 'this_month', name: 'This month', id: 1 },
    { var: 'this_quarter', name: 'This quarter', id: 2 },
    { var: 'this_financial_year', name: 'This financial year', id: 3 },
    { var: 'last_month', name: 'Last month', id: 4 },
    { var: 'last_financial_year', name: 'Last financial year', id: 6 },
    { var: 'month_to_date', name: 'Month to date', id: 7 },
    { var: 'last_quarter', name: 'Last quarter', id: 5 },
    { var: 'quarter_to_date', name: 'Quarter to date', id: 8 },
    { var: 'year_to_date', name: 'Year to date', id: 9 },
    { var: 'custom_date', name: 'Custom Date', id: 14 },
    { var: 'calendar_year', name: 'Calendar year', id: 13 },
    { var: 'all', name: 'All', id: 10 },
    // { var: 'weekly_stats', name: 'Chart Per Week', id: 5 },
  ];

  public static DateChart = [
    { id: 100, name: 'Last 7 Days' },
    { id: 101, name: 'Last week' },
    { id: 102, name: 'This week' },
    { id: 103, name: 'Prev Month' },
    { id: 104, name: 'This Month' },
    { id: 201, name: 'Prev Quarter' },
    { id: 202, name: 'This Quarter' },
    { id: 208, name: 'Quarter to date' },
    { id: 105, name: 'Month to date' },
    { id: 205, name: 'This Financial Year' },
    { id: 206, name: 'Last Financial Year' },
    { id: 203, name: 'Yearly' },
    { id: 207, name: 'Year To Date' },
    { id: 106, name: 'Custom' },
    { id: 204, name: 'All' },
  ];

  public static loadDate_Range = () => {
    const today = new Date();
    const quarter = Math.floor(today.getMonth() / 3);
    const startFullQuarter = new Date(today.getFullYear(), quarter * 3, 1);
    const endFullQuarter = new Date(startFullQuarter.getFullYear(), startFullQuarter.getMonth() + 3, 0);
    const laststartFullQuarter = new Date(today.getFullYear(), quarter * 3 - 3, 1);
    const lastendFullQuarter = new Date(laststartFullQuarter.getFullYear(), laststartFullQuarter.getMonth() + 3, 0);
    let dateRange = [];
    // const currentYear = moment().year(); // Get current year dynamically
    const fy = createReport.fiscalYearJulyJune(moment(today));

    dateRange.push({
      id: 99,
      name: 'Today',
      format: 'dd MMM YYYY',
      from: moment(today).startOf('day').toDate(),
      to: moment(today).endOf('day').toDate(),
    });
    dateRange.push({
      id: 100,
      name: 'Last 7 Days',
      format: 'dd MMM YYYY',
      from: moment(today).subtract(6, 'days').startOf('day').toDate(),
      to: moment(today).endOf('day').toDate(),
    });
    dateRange.push({
      id: 101,
      name: 'Last Week',
      format: 'dd MMM YYYY',
      from: moment(today).subtract(1, 'week').startOf('isoWeek').toDate(),
      to: moment(today).subtract(1, 'week').endOf('isoWeek').toDate(),
    });
    dateRange.push({
      id: 102,
      name: 'This Week',
      format: 'dd MMM YYYY',
      from: moment(today).startOf('isoWeek').toDate(),
      to: moment(today).endOf('isoWeek').toDate(),
    });
    dateRange.push({
      id: 103,
      name: 'Prev Month',
      format: 'MMM YYYY',
      from: moment(today).subtract(1, 'months').startOf('month').toDate(),
      to: moment(today).subtract(1, 'months').endOf('month').toDate(),
    });
    dateRange.push({
      id: 104,
      name: 'This Month',
      format: 'MMM YYYY',
      from: moment(today).startOf('month').toDate(),
      to: moment(today).endOf('month').toDate(),
    });
    dateRange.push({
      id: 105,
      name: 'Month To Date',
      format: 'dd MMM YYYY',
      from: moment(today).startOf('month').toDate(),
      to: moment(today).toDate(),
    });
    dateRange.push({
      id: 201,
      name: 'Prev Quarter',
      format: 'MMM YYYY',
      from: moment(laststartFullQuarter).toDate(),
      to: moment(lastendFullQuarter).toDate(),
    });
    dateRange.push({
      id: 202,
      name: 'This Quarter',
      format: 'MMM YYYY',
      from: moment(startFullQuarter).toDate(),
      to: moment(endFullQuarter).toDate(),
    });
    dateRange.push({
      id: 203,
      name: 'Yearly',
      format: 'dd MMM YYYY',
      from: moment(today).startOf('year').format('DD MMM YYYY'),
      to: moment().endOf('year').format('DD MMM YYYY'),
    });
    dateRange.push({
      id: 205,
      name: 'This Financial Year',
      format: 'dd MMM YYYY',
      from: fy.current.start.toDate(),
      to: fy.current.end.toDate(),
    });
    dateRange.push({
      id: 206,
      name: 'Last Financial Year',
      format: 'dd MMM YYYY',
      from: fy.last.start.toDate(),
      to: fy.last.end.toDate(),
    });
    dateRange.push({
      id: 207,
      name: 'Year To Date',
      format: 'dd MMM YYYY',
      from: moment(today).startOf('year').toDate(),
      to: moment(today).toDate(),
    });
    dateRange.push({
      id: 208,
      name: 'Quarter to date',
      format: 'dd MMM YYYY',
      from: moment(startFullQuarter).startOf('month').toDate(),
      to: moment(today).toDate(),
    });
    dateRange.push({
      id: 204,
      name: 'All',
      format: 'dd MMM YYYY',
      from: '',
      to: '',
    });
    return dateRange;
  };
}
